module.exports = __webpack_public_path__ + "static/media/dark-motion-adcs-design.888a542.mp4";